export default __webpack_public_path__ + "shareable1f048c.png";